import { useEffect } from 'react';

export default function BlueskyEmbed({ updateOn }: any) {
  useEffect(() => {
    let script: HTMLScriptElement | null = null;
    try {
      script = document.createElement('script');
      script.src = 'https://embed.bsky.app/static/embed.js';
      script.setAttribute('data-bluesky-embed', 'true');
      document.body.appendChild(script);
    } catch {
      /*swallow exception*/
    }

    // Cleanup script on unmount to prevent orphaned nodes
    return () => {
      try {
        if (script?.parentNode) {
          script.parentNode.removeChild(script);
        }
      } catch {
        // Script already removed, safe to ignore
      }
    };
  }, [updateOn]);

  return null;
}
